import React, { useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import ButtonText from "../../../components/buttons/button.text";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";
import AccessoiresQuestion from "../../../components/questions/AccessoiresQuestion";
import {useSnackbar} from "notistack";

// Prêts aux particuliers à l'accession à la propriété (PAS, PSI, PTZ+) ou prêts à la construction garantis par une hypothèque conventionnelle
// simulateur id 85

function Simulateur_A1_12VEFA(props) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const currentIdSimu = 85;
  const [montant_pret, setMontant] = useState(0);
  const [montant_pret_hp, setMontant_pret_hp] = useState(0);
  const [montant_pret_hc, setMontant_pret_hc] = useState(0);
  const [departement, setDepartement] = useState(0);
  const [pret_realise, setPret] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [modifAccessoires, setModifAccessoires] = useState(0);
  const [tauxAccessoires, setTauxAccessoires] = useState(20);

  const handleChange = async (setter, value, key) => {
    if (key === "taux_accessoires" && value >= 100) {
      enqueueSnackbar('Le pourcentage maximal des accessoires est de 100%', {
        variant: 'warning'
      });
      value = 100
    }
    setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    let object = {
      simulateurid: currentIdSimu,
      departementid: parseInt(departement),
      inputs: {
        montant_pret_hp: parseInt(montant_pret_hp),
        montant_pret_hc: parseInt(montant_pret_hc),
        montant_pret: parseInt(montant_pret),
        pret_realise: parseInt(pret_realise),
        montant_deb_add: parseInt(montantDeboursAdditionnels),
        debours_additionnels: parseInt(deboursAdditionnels),
        modif_accessoires: parseInt(modifAccessoires),
        taux_accessoires: parseFloat(tauxAccessoires),
        convention_honoraires : parseInt(props.conventionHonoraires),
      },
      pdfInputs: {
        nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
        object_convention_honoraires : props.objectConventionHonoraires,
        montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
        nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
        adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
      },
    };
    //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
        if (key === "modif_accessoires") {
          if (value === 0) {
            setTauxAccessoires(20);
            Object.assign(object["inputs"], { taux_accessoires: parseFloat(20) });
          }
          Object.assign(object["inputs"], { modif_accessoires: parseInt(value) });
        }
        if (key === "taux_accessoires") {
          Object.assign(object["inputs"], { taux_accessoires: parseFloat(value) });
        }
      }
      //For internal settings
    if (setter === setMontant_pret_hp) {
      Object.assign(object["inputs"], { montant_pret_hp: parseInt(value) });
    }

    if (setter === setMontant_pret_hc) {
      Object.assign(object["inputs"], { montant_pret_hc: parseInt(value) });
    }

    if (setter === setMontant) {
      Object.assign(object["inputs"], { montant_pret: parseInt(value) });
    }

    if (setter === setPret) {
      Object.assign(object["inputs"], { pret_realise: parseInt(value) });
    }

    if (setter === setDepartement) {
      object.departementid = parseInt(value);
    }

    if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }
    //props.contentDep(object);
    if (props.isParent) {
      dispatch(setSimulateurObject(object));
    } else {
      object.departementid = parseInt(props.departementId);
      props.dependances(object);
    }
  }

  return (
    <>
      {props?.isParent === true && props.departements !== "" ? (
        <div style={styles.container}>
          <div className="cardSimulateur">
            {/* <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} /> */}
            <TextSimulateurTitle title={"Prêts aux particuliers à l'accession à la propriété (PAS, PSI, PTZ+) ou prêts à la construction garantis par une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)"} currentSimuId={props.simulateur.id} />

            <TextfieldRemarques handleChange={handleChangeRemarque} />

            <p style={styles.cardSubTitle}>
              Pour le prêt, acte tarifé au titre du Tableau 5, n° 137 (Art A444-143).
              Cautionnement associé acte tarifé au titre du Tableau 5, n° 111 (Art A444-127).
            </p>

            {props?.isParent === true && props.departements !== "" ? (
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>Département :</div>

                <SelectDepartement
                  items={props.departements}
                  nameField={"name"}
                  defaultValue={currUserDep}
                  optionValue={"id"}
                  handleChange={handleChange}
                  setter={setDepartement}
                />
              </div>
            ) : (
              <></>
            )}

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>L'acte de prêt est réalisé :</div>
              <ButtonText handleChange={handleChange} setter={setPret} defaultValue={0} />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Indiquer le montant total du prêt aidé et du prêt garanti par une hypothèque légale de prêteur de
                deniers et/ou HC :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setMontant}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Indiquer le montant du prêt soumis à un prêt aidé et/ou hypothèque légale de prêteur de deniers :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setMontant_pret_hp}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Indiquer le montant du prêt faisant l'objet d'une hypothèque (HC) :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setMontant_pret_hc}
              />
            </div>

            <AccessoiresQuestion
              handleChange={handleChange}
              modifAccessoires={modifAccessoires}
              setModifAccessoires={setModifAccessoires}
              setTauxAccessoires={setTauxAccessoires}
            />

            <DeboursQuestion
                handleChange={handleChange}
                deboursAdditionnels={deboursAdditionnels}
                setDeboursAdditionnels={setDeboursAdditionnels}
                setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
            />
            <ConventionHonoraires
              handleChange={handleChange}
              conventionHonoraires={props.conventionHonoraires}
              setConventionHonoraires={props.setConventionHonoraires}
              nombreConventionHonoraires={props.nombreConventionHonoraires}
              setNombreConventionHonoraires={props.setNombreConventionHonoraires}
              objectConventionHonoraires={props.objectConventionHonoraires}
              setObjectConventionHonoraires={props.setObjectConventionHonoraires}
              montantConventionHonoraires={props.montantConventionHonoraires}
              setMontantConventionHonoraires={props.setMontantConventionHonoraires}
              nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
              setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
              adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
              setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
            />
          </div>
        </div>
      ) : (
        <div style={styles.cardRowChild}>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>L'acte de prêt est réalisé :</div>
            <ButtonText handleChange={handleChange} setter={setPret} defaultValue={0} />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer le montant total du prêt aidé et du prêt garanti par une hypothèque légale de prêteur de deniers
              et/ou HC :
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontant}
            />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer le montant du prêt soumis à un prêt aidé et/ou hypothèque légale de prêteur de deniers :
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontant_pret_hp}
            />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer le montant du prêt faisant l'objet d'une hypothèque (HC) :
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontant_pret_hc}
            />
          </div>

          <AccessoiresQuestion
            handleChange={handleChange}
            modifAccessoires={modifAccessoires}
            setModifAccessoires={setModifAccessoires}
            setTauxAccessoires={setTauxAccessoires}
          />
        </div>
      )}
    </>
  );
}

export default Simulateur_A1_12VEFA;
